import { logOut } from "../auth/Auth";
import Storage from "./Storage";
import { translate } from "./Translation";

export default class API {
    dev = true;
    url = "https://api.toptest.eu/api";
    routes = {};

    constructor(routes) {
        this.routes = routes;
    }

    route(name, params = {}, local = false) {
        let route = this.routes[name];
        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                route = route.replace(":" + key, params[key]);
            }
        }

        if(local){
            //eslint-disable-next-line
            return location.protocol + "//" + location.hostname + route;
        }

        return this.url + route;
    }

    async request(args) {

        const def = {
            method: "get",
            data: false,
            route: false,
            loader: true,
            local: false,
            params: {},
            cache: false,
            done: (response, promise) => {
            },
            success: (response, promise) => {
            },
            created: (response, promise) => {
            },
            failure: (response, promise) => {
                // Run on different "thread"
                setTimeout(() => {
                    console.log(response.message);
                    alert(response.message);
                })
            },
            error: (response) => {
                // Run on different "thread"
                setTimeout(() => {
                    console.log(response.message);
                    alert(translate("Please contact system administrator.") + "\n\n" + response.message);
                })
            }
        };

        // Merge arguments with defaults
        args = Object.assign(def, args);

        // Global cache disable
        args.cache = false;

        let body = undefined;

        if (args.data) {
            body = new FormData();
            body.append("data", JSON.stringify(args.data));
            if (args.data.files) {
                for (let i = 0; i < args.data.files.length; i++) {
                    const file = args.data.files[i];
                    body.append(file.name, file);
                }
            }
            args.method = "post";
        }

        let url = this.route(args.route, args.params, args.local);

        let active_weaveGroup_filter = Storage.get("weaveGroup_filter", true);
        let active_weaves_filter = Storage.get("weaves_filter", true);
        
        if (active_weaveGroup_filter !== null && active_weaveGroup_filter.id !== "all") {
            url += (url.indexOf("?") > -1 ? "&" : "?") + "weaveGroup=" + active_weaveGroup_filter.id;
        }

        if (active_weaves_filter !== null && active_weaves_filter.id !== "all" && url.indexOf("api/statistic_error") === -1) {
            url += (url.indexOf("?") > -1 ? "&" : "?") + "weave=" + active_weaves_filter.id;
        }

        if (args.cache && Storage.storeHasKey("cache", url)) {

            let cache = Storage.get("cache")[url];

            args.done(cache.response, cache.promise);

            switch (cache.status) {
                case 200: {
                    args.success(cache.response, cache.promise);
                    break;
                }
                case 201: {
                    args.created(cache.response, cache.promise);
                    break;
                }
                case 401: {
                    logOut();
                    break;
                }
                case 400: {
                    args.failure(cache.response, cache.promise);
                    break;
                }
                default: {
                    args.error(cache.response, cache.promise);
                }
            }

            return;
        }

        if (url.indexOf("auth") > -1 || url.indexOf("add") > -1 || url.indexOf("edit") > -1 || url.indexOf("delete") > -1 || url.indexOf("remove") > -1 || url.indexOf("save") > -1 || url.indexOf("fill") > -1) {
            Storage.del("cache");
        }

        if(args.loader) {
            document.getElementById("ajax_loading").style.display = "block";
            document.getElementById("ajax_loading").style.position = "fixed";
            document.getElementById("ajax_loading").style.zIndex = "999999";
        }


        const promise = await fetch(url,
            {
                method: args.method,
                body: body,
                headers: {
                    "Authentication-Token": Storage.get("atoken")
                }
            });
        const response = await promise.json();

        if(args.loader) {
            document.getElementById("ajax_loading").style.display = "none";
            document.getElementById("ajax_loading").style.zIndex = "999999";
        }

        if (args.cache) {

            const cacheData = {};
            cacheData[url] = {
                "status": promise.status,
                "promise": promise,
                "response": response,
            };

            Storage.append("cache", cacheData);
        }

        args.done(response, promise);

        switch (promise.status) {
            case 200: {
                args.success(response, promise);
                break;
            }
            case 201: {
                args.created(response, promise);
                break;
            }
            case 401: {
                alert(response.message);
                logOut();
                break;
            }
            case 400: {
                args.failure(response, promise);
                break;
            }
            default: {
                alert(promise.status);
                args.error(response, promise);
            }
        }

    }

}


// WEBPACK FOOTER //
// ./src/modules/base/API.js